import { httpRequest } from "../../http";
import { CatalogMetric, MetricIn } from "@models/catalog.model";

const COLL = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/catalog/metrics/`;

export class CommandCreateMetric {
  async run(payload: MetricIn): Promise<CatalogMetric> {
    return httpRequest<CatalogMetric>(COLL, { method: "POST", body: payload });
  }
}

export class CommandUpdateMetric {
  async run(id: number, payload: MetricIn): Promise<CatalogMetric> {
    return httpRequest<CatalogMetric>(`${COLL}${id}/`, { method: "PUT", body: payload });
  }
}

export class CommandDeleteMetric {
  async run(id: number): Promise<void> {
    await httpRequest(`${COLL}${id}/`, { method: "DELETE" });
  }
}
